(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cro-compact-reviews"] && !Shopify.designMode) return;
  try {
    
  function croRegisterCompactReviews() {
    const styleElement = document.querySelector('[data-cro-review-widget-style]');
    if (!styleElement || typeof window.gw?.registerWidgetCustomization !== 'function') return;
    window.gw.registerWidgetCustomization(
      widgetConfig => ['ReviewsListWidget', 'ReviewsListWidgetV2'].includes(widgetConfig.widgetName),
      () => ({ styleElement })
    );
  }
  if (window.gw?.sdk) {
    croRegisterCompactReviews();
  } else {
    document.addEventListener('gwSdkReady', croRegisterCompactReviews, { once: true });
  }

  } catch(e) { console.error(e); }
})();
})();
